import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import "./perfilCadastro.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getPerfilCadastro,
  getPerfilById,
  getPerfilUpdate,
} from "../../services/api_cadastro_perfis";
import {
  getPerfilAcessos,
  updatePerfilAcessos,
} from "../../services/api_perfil_acesso";
import Swal from "sweetalert2";
import { FaCheckSquare, FaSquare } from "react-icons/fa";

const entidades = [
  "Aplicacao",
  "AplicacaoPlanoManutencao",
  "Empresa",
  "GrupoMaterial",
  "MateriaisServico",
  "Material",
  "MaterialPlano",
  "OrdensServico",
  "Perfil",
  "PerfilAcesso",
  "Pessoa",
  "PessoaServicoOrdem",
  "PessoaSetorExecutante",
  "PlanosManutencao",
  "ProcedimentosPlano",
  "Servicos",
  "ServicosOrdem",
  "SetoresExecutantes",
  "SolicitacaoServico",
  "TipoManutencao",
  "TiposAplicacao",
  "Unidade",
  "UnidadeMedida",
  "User",
  "AplicGarServ",
  "HistogrServ", 
  "HistManServ", 
  "InvCliSv"
];

// Função para formatar o nome das entidades para exibição
const formatarEntidade = (nome) => {
  return nome.replace(/([A-Z])/g, " $1").trim();
};

const PerfilRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [nome, setNome] = useState("");
  const [permissoes, setPermissoes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [isLoadingPerfil, setIsLoadingPerfil] = useState(true);
  const [isLoadingAcessos, setIsLoadingAcessos] = useState(true);
  const [isSaving, setSaving] = useState(false);
  const [allSelected, setAllSelected] = useState(false)

  useEffect(() => {
    const fetchPerfilById = async () => {
      try {
        const response = await getPerfilById(id);
        const perfil = response.data.perfil;
        setNome(perfil.nome || "");
        setPermissoes(perfil.permissoes || []);
      } catch (error) {
        console.error("Erro ao obter dados do perfil:", error);
      } finally {
        setIsLoadingPerfil(false);
      }
    };

    const fetchPerfilAcessos = async () => {
      try {
        const response = await getPerfilAcessos(id);
        const pessoaPermissoes = response.pessoa || [];
        setPermissoes(pessoaPermissoes);
      } catch (error) {
        console.error("Erro ao obter acessos do perfil:", error);
        setPermissoes([]);
      } finally {
        setIsLoadingAcessos(false);
      }
    };

    if (id) {
      fetchPerfilById();
      fetchPerfilAcessos();
    } else {
      setIsLoadingPerfil(false);
      setIsLoadingAcessos(false);
    }
  }, [id]);

  const handleCloseModal = () => setShowModal(false);

  const handleOpenModal = (title, body) => {
    //setModalContent({ title, body });
    //setShowModal(true);
  };

  const validarInputs = () => {
    if (!nome) {
      Swal.fire({
        icon: "info",
        title: "O campo Nome é obrigatório",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getPerfilCadastro(body);
      if (response && response.status === 200) {
        return response; // Retorna a resposta para ser usada mais tarde
      } else {
        throw new Error("Erro ao cadastrar perfil");
      }
    } catch (error) {
      console.error("Erro ao cadastrar perfil:", error);
      throw error;
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getPerfilUpdate(id, body);
      if (response && response.status === 200) {
        return response; // Retorna a resposta para ser usada mais tarde
      } else {
        throw new Error("Erro ao atualizar perfil");
      }
    } catch (error) {
      if (error.response?.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response?.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        handleOpenModal(
          "Erro ao atualizar o perfil",
          "Por favor, tente novamente mais tarde."
        );
      }
      throw error; // Propaga o erro para que possa ser capturado no handleSalvar
    }
  };

  const handleSalvar = async () => {
    if (validarInputs()) {
      setSaving(true);
      try {
        if (id) {
          const body = {
            nome,
            permissoes: permissoes.map((p) => ({
              id: p.id,
              view: p.view || 0,
              store: p.store || 0,
              update: p.update || 0,
              delete: p.delete || 0,
            })),
          };
          await newUpdate(body); // Atualizar nome do perfil
          await updatePerfilAcessos(body.permissoes); // Atualizar permissões
          navigate("/perfis"); // Redirecionar para a lista de perfis
        } else {
          // Criação do perfil
          const response = await addCadastro({ nome });
          if (response && response.status === 200) {
            const newProfileId = response.data.perfil.id;
            const permissoesResponse = await getPerfilAcessos(newProfileId);
            const permissoesIniciais = permissoesResponse.pessoa || [];
            const permissoesAtualizadas = permissoesIniciais.map((p) => {
              const permissaoUsuario = permissoes.find(
                (pu) => pu.entidade === p.entidade
              );
              return {
                id: p.id,
                view: permissaoUsuario ? permissaoUsuario.view || 0 : p.view,
                store: permissaoUsuario ? permissaoUsuario.store || 0 : p.store,
                update: permissaoUsuario
                  ? permissaoUsuario.update || 0
                  : p.update,
                delete: permissaoUsuario
                  ? permissaoUsuario.delete || 0
                  : p.delete,
              };
            });
            await updatePerfilAcessos(permissoesAtualizadas);
            navigate("/perfis"); // Redirecionar para a lista de perfis
          } else {
            throw new Error("Erro ao cadastrar perfil");
          }
        }
      } catch (error) {
        console.error("Erro ao salvar perfil:", error);
        if (error.response?.status === 422) {
          handleOpenModal(
            "Erro de validação",
            "Houve um erro na validação dos dados."
          );
        } else if (error.response?.status === 500) {
          handleOpenModal(
            "Erro interno do servidor",
            "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
          );
        } else {
          handleOpenModal(
            "Erro ao salvar o perfil",
            "Por favor, tente novamente mais tarde."
          );
        }
      } finally {
        setSaving(false); // Desativa o spinner após o salvamento
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 15) {
      setNome(value);
    } else {
      Swal.fire({
        icon: "info",
        title: "O Campo Nome não pode ultrapassar 15 caracteres",
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSalvar();
    }
  };

  const handlePermissaoChange = (entidade, campo, value) => {
    setPermissoes((prevPermissoes) => {
      const permissaoExistente = prevPermissoes.find(
        (p) => p.entidade === entidade
      );
      const novaPermissao = permissaoExistente
        ? { ...permissaoExistente, [campo]: value ? 1 : 0 }
        : {
            entidade,
            [campo]: value ? 1 : 0,
            view: 0,
            store: 0,
            update: 0,
            delete: 0,
          };

      return [
        ...prevPermissoes.filter((p) => p.entidade !== entidade),
        novaPermissao,
      ];
    });
  };

  const handleSelectAllPermissions = (value) => {
    setPermissoes((prevPermissoes) => {
      const novasPermissoes = entidades.map((entidade) => {
        const permissaoExistente = prevPermissoes.find(
          (p) => p.entidade === entidade
        );
  
        return permissaoExistente
          ? {
              ...permissaoExistente,
              view: value ? 1 : 0,
              store: value ? 1 : 0,
              update: value ? 1 : 0,
              delete: value ? 1 : 0,
            }
          : {
              entidade,
              view: value ? 1 : 0,
              store: value ? 1 : 0,
              update: value ? 1 : 0,
              delete: value ? 1 : 0,
            };
      });
  
      console.log("Novas permissões:", novasPermissoes); // Adicione esse log
      return novasPermissoes;
    });
  };
  
  const toggleSelectAll = () => {
    const novoValor = !allSelected;
    setAllSelected(novoValor);
    handleSelectAllPermissions(novoValor); // Chama a função para selecionar ou desmarcar todas
  };


  const regret = () => {
    navigate("/perfis"); // Redireciona para a lista de perfis sem salvar
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Perfis" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoadingPerfil || isLoadingAcessos ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Form className="mt-4" onKeyPress={handleKeyPress}>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formNome">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a descrição"
                    value={nome}
                    onChange={handleCaracteres}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <h5>Permissões</h5>
                <table className="table">
                <thead>
                    <tr>
                      <th>Entidade</th>
                      <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <Button
                          variant="white"
                          onClick={toggleSelectAll}
                          className="text-dark p-0"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                          }}
                        >
                          {allSelected ? <FaCheckSquare /> : <FaSquare />} 
                          {allSelected ? " Desmarcar Todas" : " Selecionar Todas"}
                        </Button>
                      </th>
                      <th>View</th>
                      <th>Store</th>
                      <th>Update</th>
                      <th>Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    {entidades.map((entidade) => {
                      const permissao =
                        permissoes.find((p) => p.entidade === entidade) || {};
                      return (
                        <tr key={entidade}>
                          <td>{formatarEntidade(entidade)}</td>
                          <td>
                            
                          </td>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={permissao.view === 1}
                              className="ml-4 custom-checkbox"
                              onChange={(e) =>
                                handlePermissaoChange(
                                  entidade,
                                  "view",
                                  e.target.checked
                                )
                              }
                            />
                          </td>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={permissao.store === 1}
                              className="ml-4 custom-checkbox"
                              onChange={(e) =>
                                handlePermissaoChange(
                                  entidade,
                                  "store",
                                  e.target.checked
                                )
                              }
                            />
                          </td>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={permissao.update === 1}
                              className="ml-4 custom-checkbox"
                              onChange={(e) =>
                                handlePermissaoChange(
                                  entidade,
                                  "update",
                                  e.target.checked
                                )
                              }
                            />
                          </td>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={permissao.delete === 1}
                              className="ml-4 custom-checkbox"
                              onChange={(e) =>
                                handlePermissaoChange(
                                  entidade,
                                  "delete",
                                  e.target.checked
                                )
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled={isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default PerfilRegister;
